import React, { useEffect, useState } from "react";
import TabellaLista from "../Tabella/TabellaLista";
import { ColumnFilter } from "../table/FilteringTable/ColumnFilter";
import MyApiClient from "../../../api-client/MyApiClient";
import { sportsRoles } from "../Util/enum";
import { livelliCertificati, righeSportPraticati } from "./certificazioniSportive";

/*
 * «Sport praticati» nella scheda del player e del junior (segnalazione del 04/11/2026): il livello è quello
 * certificato da un maestro, con il nome che usa quello sport, «0» se non c'è, con data e maestro. Tolta la colonna
 * «Skill»: le skill stanno nella tab «Traguardi». Prima «Livello» e «Skill» erano percentuali di completamento.
 */

const ruolo = (valore) => sportsRoles.find((r) => r.value === valore)?.label || '';

export const SportPraticati = ({ userId, sports, conStaff = true }) => {
    const [livelli, setLivelli] = useState({});

    useEffect(() => {
        if (!userId) return undefined;
        let attivo = true;
        const token = JSON.parse(sessionStorage.getItem('userDetails') || '{}').idToken;
        new MyApiClient().getSportsLevels(token, userId).then((r) => {
            if (attivo) setLivelli(r?.error ? {} : livelliCertificati(r));
        });
        return () => { attivo = false; };
    }, [userId]);

    const colonne = [
        { Header: 'Sport', accessor: 'sport', Filter: ColumnFilter },
        { Header: 'Livello', accessor: 'level', Filter: ColumnFilter },
        { Header: 'Certificato il', accessor: 'certifiedAt', Filter: ColumnFilter, compact: true },
        { Header: 'Maestro', accessor: 'coach', Filter: ColumnFilter },
        { Header: 'Ruolo', accessor: 'role', Filter: ColumnFilter },
        ...(conStaff ? [{ Header: 'Staff tecnico', accessor: 'staff', Filter: ColumnFilter }] : []),
    ];

    return (
        <TabellaLista
            cardTitle={'Sport praticati'}
            hasSearch={false}
            hasFilter={false}
            hasAddMore={false}
            data_column={colonne}
            data_json={sports ? righeSportPraticati(sports, livelli, ruolo) : null}
        />
    );
};

export default SportPraticati;
